"use strict";

$.ajaxSetup({
    xhrFields: {
        withCredentials: true
    },
    dataType: 'json'
})

Vue.component('count-time', {
    props: {
        endtime: {
            type: ''
        },
        unit: {
            type: String,
            default: '剩余'
        },
        unittext: {
            type: String,
            default: ''
        }
    },
    created: function created() {
    },
    data: function data() {
        return {
            time: '',
            time2: '',
            flag: false
        };
    },
    template: "<div class=\"slottext\"><span>{{unit}}</span><span class=\"noday\" v-html=\"time\"></span><span>{{unittext}}</span></div>",
    // template: "<div class=\"slottext\"><span>{{unit}}</span> <span class=\"addday\" v-html=\"time2\"></span><span>{{unittext}}</span></div>",
    mounted: function mounted() {
        var _this = this;


        var time = setInterval(function () {
            if (_this.flag == true) {
                clearInterval(time);
            }

            _this.timedown();
        }, 500);
    },
    methods: {
        timedown: function timedown() {
            var endTime = new Date(this.endtime * 1000);
            var nowTime = new Date();
            var leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
            var d = parseInt(leftTime / (24 * 60 * 60));
            var h = this.formate(parseInt(leftTime / (60 * 60) % 24));
            var m = this.formate(parseInt(leftTime / 60 % 60));
            var s = this.formate(parseInt(leftTime % 60));

            if (leftTime <= 0) {
                this.flag = true;
                this.$emit('time-end');
            }

            if(d > 0 ){
                this.time = '<span class="hasbg">' + d + '</span>' + '天' + '<span class="hasbg">' + h + '</span>' + '时' + '<span class="hasbg">' + m + '</span>' + '分';
            } else {
                this.time = '<span class="hasbg">' + h + '</span>' + ':' + '<span class="hasbg">' + m + '</span>' + ':' + '<span class="hasbg">' + s + '</span>';
            }
        },
        formate: function formate(time) {
            if (time >= 10) {
                return time;
            } else {
                return "0".concat(time);
            }
        }
    }
});


Vue.component('limitfree-time', {
    props: {
        endtime: {
            type: ''
        }
    },
    created: function created() {
        this.timedown()
    },
    data: function data() {
        return {
            time: ''
        };
    },
    template: "<span>{{time}}</span>",
    methods: {
        timedown: function timedown() {
            let _this = this
            let date = _this.endtime * 1000,
                day = 0,
                hours = 0,
                minutes = 0
            setInterval(() => {
                date -= 1000
                day = `${parseInt(date / (60 * 60 * 24 * 1000))}`
                hours = `${parseInt((date - day * 86400000) / (60 * 60 * 1000))}`.padStart(2, 0)
                minutes = `${parseInt((date - day * 86400000 - hours * 3600000) / 60000)}`.padStart(2, 0)
                _this.time = `${day}天${hours}时${minutes}分`

                if(date == 0){
                    _this.$emit('timeEnd');
                }
            }, 1000)
        }
    }
});


var new_detail = new Vue({
    el: '#new_detail',
    mixins: [myminxin],
    data: {
        islogin: false,
        // 判断是否登录
        recordinfo: {},
        //
        isbargin: 0,
        // 是否是砍价
        isbar: false,
        // 砍价弹窗是否显示
        barStep: 0,
        // 砍价弹窗
        friendslist: '',
        // 砍价好友列表弹窗之内
        friends: '',
        // 砍价好友 详情页
        barnum: 0,
        // 砍价好友数
        mandatenum: 0,
        // 要求砍价好友数量
        ykprice: 0,
        // 砍掉的价钱
        sybarnum: 0,
        // 还需邀请好友数
        statusbar: '-1',
        // 是否开始砍价
        islingqu: '0',
        // 是否领取了砍价神器   0 未领取 1 已领取 2 已使用
        reach: false,
        // 是否达到了领取神器的条件
        iphone: '',
        //手机号
        iphonecode: '',
        //验证码
        byiphone: true,
        // 手机号验证通过之后 验证码高亮显示
        btntext: '发送验证码',
        bindiphonetext: '完成',
        isbindall: true,
        countdown: '',
        // 倒计时样式
        getCodeTime: 60,
        // 获取验证码之后的倒计时
        iserror: false,
        // 错误信息图标
        errortext: '',
        // 绑定手机号不通过提示信息
        fristprice: '',
        // 第一次砍了多少钱
        barendtime: '',
        // 开始砍价时间
        isendbar: '',
        // 砍价是否结束  0正在砍价 1-砍价结束,待支付 2-砍价信息过期或没有发起砍价 3-已支付
        endtimepay: '',
        // 支付倒计时
        shareLike: '',
        // 邀请好友二维码
        timeInterval: '',
        alertActicvdemo: 1544524302,
        course_id: course_id,
        //    课程id
        pddOrderId: '',
        //    个人拼团订单id
        list: [],
        //    小团人数数据
        isCollagedtime: false,
        //    邀请好友开团开关
        v_courseId: '',
        is_bound: '',
        //    绑定
        is_baoming: 0,
        //    是否报名
        in_cart: 0,
        //    是否在购物车
        room_id: 0,
        //    直播间id 0 没有直播  不为0 有直播，此变量为直播间id
        is_pdd: 0,
        //    是否开启小团了
        is_force: '',
        //    是否强制拼团 0 未开启 1 已开启
        course_info: [],
        //    课程信息
        course_image: '',
        //    课程图片
        video_size: 0,
        //    当前课程是否有视频 1 有 0 没有
        v_course_id: 0,
        //    视频总记录id
        room_url: '',
        //    直播间链接
        bao_url: '',
        //    报名链接
        uid: 0,
        //    用户id
        ins: 0,
        collageMore: false,
        //    查看更多
        is_dist: 0,
        //    是否开启分销
        dist_info: [],
        //    分销信息
        vip_play: 0,
        //    买18年vip送一个月白名单视频观看权限
        distcode: distcode,
        //    分销码
        pdd_info: [],
        //    小团信息
        isOpenGroup: false,
        //    一键开团开关
        groupon_status: 0,
        //    拼团状态 1未 2已在团 3别人分享团 * （有团不会出现）
        show_qq: 0,
        //显示不显示qq群
        groupon_code: groupon_code,
        syllabusList: [],
        sh_pic: '',
        showerma: '',
        distributionInfo: {},
        //    分销信息
        isBarrageList: {},
        barrageList: {},
        msgname: '',
        name: '',
        //    小团开团名字
        phone: '',
        msgphone: '',
        qq: '',
        msgqq: '',
        wraploading: true,
        isDistribution: false,
        isWeixinShare: false,
        isAttention: false,
        isaudition: false,
        isLeranStudy: false,
        isVideoLog: false,
        isGroudpdd: false,
        isAudition: 0,
        auditionTime: '',
        myselfEndTime: '',
        pddTeamPerson: [],
        pddTeamPersonNum: '',
        isPaytime: '',
        isPaytimezore: '',
        tabs: ['介绍', '大纲'],
        opengroup: "一键开团",
        num: 0,
        message: '正在倒计时',
        isbuy: false,
        // 单集购买支付弹窗是否显示
        Interval: '',
        // 计时器
        laterPrice: '',
        // 原价
        nowPrice: '',
        // 现价
        price: '',
        // 单集购买价钱
        classname: '',
        //课时名称
        classid: '',
        // 课时id
        step: 1,
        // 弹窗显示
        oid: '',
        // 订单编号,
        userimg: '',
        //用户头像
        orderIdInvite: '',
        isdisabled: false,
        distributionRanking: '',
        // 赚钱排行榜数据
        isshowranking: true,
        // 是否显示排行榜数据
        rankingslice: '',
        // 前三条
        rankings: '',
        // 全部
        isshowmore: true,
        // 是否展示查看更多
        countEndtime: '', //倒计时
        isshare: 1, //是否开启分享领红包
        sharembc: false,
        openshare: 1,
        shareData: '', // 分享领红包相关数据
        toCopy: true,

        //一元订金
        depositInfo: {
            deduction_amount: "",
            deposit_amount: "",
            deposit_end_time: "",
            deposit_start_time: "",
            final_end_time: "",
            final_start_time: "",
            deposit_coupon: '',
            low_price: '',
            start_timestamp: 0
        },
        isDeposit: 0,
        depositShareModal: false,
        depositPaymentModal: false,
        user: {
            name: '',
            tel: '',
            qq: '',
            agree: false,
            hasInfo: false
        },
        userError: {
            name: false,
            tel: false,
            qq: false,
            agree: false
        },
        depositStep: 1,
        depositAmount: '',
        depositTimer: null,
        depositCoupon: {},

        //ai特训营
        is_aist: false, // 是否AI特训营
        aist_start_time: '', // AI特训营开课时间
        assist_weixin: '',

        // 限时免费
        isshowLimitFree:false,
        limitFreeStatus: 0,
        isLimitFree: false,
        limitFreeTime:0,

        // 拼团||单集支付弹窗优化添加支付宝支付
        orderDateId:'', // 参团pdd_order_id
        isPayType: 0, // 0参团支付、1单集支付
        newPaymentWay: [
            {
                src:'https://julyedu-img-public.oss-cn-beijing.aliyuncs.com/Public/Image/pay/pay_sign_weixin.png',
                type: 1,
                alt:'微信'
            },
            {
                src:'https://julyedu-img-public.oss-cn-beijing.aliyuncs.com/Public/Image/pay/pay_sign_zhifubao.png',
                type: 2,
                alt:'支付宝'
            }
        ],
        newPayCutIndex: 0,
        newPayOrderId: '',// 新下单订单号
        payComplete:false,
    },
    filters: {
        myparseInt: function myparseInt(value) {
            return parseInt(value);
        }
    },
    created: function created() {
        var _this = this;
        _this.initDetail();

        _this.getVipVideo();


        _this.barRecord();

        _this.isoverBar();
        _this.iskanjia();


        _this.shareactive();
        /*判断是否登录*/


        if (!getCookie('uid') && !getCookie('token')) {
            var _this = this;

            _this.islogin = false;
            _this.statusbar = '-1';
        } else {
            _this.islogin = true;
        }
    },
    mounted: function mounted() {
        var _this = this;

        _this.transFerSetTimeOut();
        if(this.islogin){
            Tool.setCookie('share_code', 'share_code', -1)
        }

        window.addEventListener('scroll', _this.handleScroll);
    },
    methods: {

        // 赚钱排行榜接口
        distRanking: function distRanking() {
            var _this = this;

            $.ajax({
                url: API + '/dist/rank_list/' + _this.course_id,
                type: 'get',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function success(data) {
                    if (data.errno == 0) {
                        _this.rankingslice = data.data.slice(0, 3);
                        _this.rankings = data.data;
                        _this.distributionRanking = _this.rankingslice;

                        if (_this.rankings.length <= 3) {
                            _this.isshowmore = false;
                        }

                        if (_this.rankings.length == 0) {
                            _this.isshowranking = false;
                        }
                    }
                }
            });
        },
        // 查看更多
        showMore: function showMore() {
            var _this = this;

            _this.distributionRanking = _this.rankings;
            _this.isshowmore = false;
        },
        initDetail: function initDetail() {
            var _this = this;

            $.ajax({
                url: BASE_URL + '/course/init_detail',
                type: 'post',
                dataType: 'json',
                data: {
                    course_id: this.course_id
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function success(data) {
                    if (data.errno == 0) {
                        _this.isLimitFree = data.data.is_limit_free;
                        _this.limitFreeStatus = data.data.limit_free_status;
                        _this.limitFreeTime = data.data.limit_free_time;
                        _this.isAudition = data.data.is_audition;
                        _this.v_courseId = data.data.v_course_id;
                        window.v_course_id = data.data.v_course_id;
                        _this.is_baoming = data.data.is_baoming;
                        _this.in_cart = data.data.in_cart;
                        _this.room_id = data.data.room_id;
                        _this.is_force = data.data.is_force;
                        _this.course_info = data.data.course_info;
                        _this.course_image = oss_url + '/Public/Image/' + _this.course_info.image_name;
                        _this.video_size = data.data.video_size;
                        _this.v_vourse_id = data.data.v_course_id;
                        _this.room_url = BASE_URL + '/live/room/' + _this.room_id;
                        _this.bao_url = BASE_URL + '/cart/buy/' + _this.course_id;
                        _this.uid = data.data.uid;
                        //一元定金
                        _this.isDeposit = data.data.is_deposit;
                        if (data.data.is_deposit) {
                            _this.depositInfo = data.data.deposit_info;
                        }

                        if (_this.is_force == 0) {
                            _this.opengroup = '一键开团';
                        } else {
                            _this.opengroup = '组团秒';
                        }

                        _this.is_aist = data.data.is_aist;
                        _this.aist_start_time = data.data.aist_start_time;
                        _this.assist_weixin = data.data.course_info.assist_weixin;
                    } else if (data.errno == 404) {
                        //-------------@ author baiwei ---------------
                        //课程不存在！
                        window.location.href = BASE_URL + "/public/500.html"; //--------------------------------------------
                    } else {
                        alert(data.msg);
                    }
                }
            });
        },
        getVipVideo: function getVipVideo() {
            var _this = this;

            $.ajax({
                url: '/course/get_vip_video',
                type: 'post',
                dataType: 'json',
                data: {
                    course_id: this.course_id,
                    'distcode': this.distcode,
                    'groupon_code': this.groupon_code
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function success(data) {
                    if (data.errno == 0) {
                        _this.vip_play = data.data.vip_play;
                        _this.show_qq = data.data.show_qq;
                        _this.is_dist = data.data.is_dist;
                        _this.dist_info = data.data.dist_info;
                        _this.is_pdd = data.data.is_pdd;
                        _this.isbargin = data.data.is_bargin; // 砍价

                        _this.recordinfo = data.data.record_info;
                        _this.mandatenum = data.data.record_info.limit_people; // 总砍价人数

                        _this.barendtime = data.data.record_info.add_time; // 砍价结束时间

                        _this.barnum = data.data.record_info.assist_num; // 已砍价好友数

                        _this.islingqu = data.data.record_info.limit_status;
                        _this.sybarnum = _this.mandatenum - _this.barnum;

                        if (_this.sybarnum <= 0) {
                            _this.reach = true;
                        }

                        if (data.data.pdd_info) {
                            _this.pdd_info = data.data.pdd_info;

                            if (data.data.pdd_info.member_info) {
                                _this.groupon_status = data.data.pdd_info.member_info.groupon_status;
                                _this.list = data.data.pdd_info.member_info.now_groupon_list; // 自己开团时间

                                if (data.data.pdd_info.member_info.groupon_member) {
                                    _this.myselfEndTime = data.data.pdd_info.member_info.groupon_member.end_time; // 开团成员

                                    _this.pddTeamPerson = data.data.pdd_info.member_info.groupon_member.groupon_member;
                                    _this.pddTeamPersonNum = data.data.pdd_info.member_info.groupon_member.number;
                                    _this.pddOrderId = data.data.pdd_info.member_info.groupon_member.pdd_order_id;
                                    _this.currentUserOrderId = data.data.pdd_info['order_id'];
                                }
                            } // 个人信息


                            if (data.data.pdd_info.user_info) {
                                _this.name = data.data.pdd_info.user_info.real_name;
                                _this.qq = data.data.pdd_info.user_info.qq;
                                _this.phone = data.data.pdd_info.user_info.mobile;
                            }
                        } //console.log(_this.course_info);


                        if (data.data.dist_info) {
                            _this.is_bound = data.data.dist_info.is_bound;
                        }
                    } else {
                        alert(data.msg);
                    }
                }
            });
        },
        // 滚动监听事件
        handleScroll: function handleScroll() {
            var _this = this;

            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            var offsetTop = document.querySelector('.course_detail_body').offsetTop

            var footer = document.querySelector('.footer').offsetTop;

            var courseDetailTop = document.querySelector('.course_kefu').offsetHeight;

            if (scrollTop >= offsetTop) {
                document.querySelector('#fixed_course_tab').setAttribute('class', 'fixed_course_tab');
                document.querySelector('.course_kefu').setAttribute('class', 'course_kefu kefu_fixed');

                if ($(document).scrollTop() >= footer - 60 - courseDetailTop - 80) {
                    document.querySelector('.course_kefu').setAttribute('class', 'course_kefu kefu_bottom');
                }
            } else {
                document.querySelector('#fixed_course_tab').setAttribute('class', '');
                document.querySelector('.course_kefu').setAttribute('class', 'course_kefu');
            }
        },
        // 调用弹幕轮询时间方法
        transFerSetTimeOut: function transFerSetTimeOut() {
            var _this = this;

            var nowDate = _this.getServerTime();

            var beginDate = new Date(nowDate);
            var endDate = new Date(nowDate);

            if (beginDate.getHours() <= 24 && beginDate.getHours() >= 23) {
                // 23~24点，刷新周期改为每30s一次
                beginDate.setHours(23, 0, 0, 0);
                endDate.setHours(24, 0, 0, 0);

                if (nowDate.getTime() - beginDate.getTime() >= 0 && nowDate.getTime() <= endDate.getTime()) {
                    // 定时器轮询
                    _this.barrageSetTimeOut(30000, 15000, 15000);
                }
            }

            if (beginDate.getHours() >= 24 && beginDate.getHours() <= 7) {
                // 0-7点，刷新周期改为每1分钟一次；
                beginDate.setHours(24, 0, 0, 0);
                endDate.setHours(7, 0, 0, 0);

                if (nowDate.getTime() - beginDate.getTime() >= 0 && nowDate.getTime() <= endDate.getTime()) {
                    // 定时器轮询
                    _this.barrageSetTimeOut(600000, 300000, 300000);
                }
            }

            if (beginDate.getHours() >= 7 && beginDate.getHours() <= 8) {
                //  7-8点，刷新周期改为每30s一次；
                beginDate.setHours(7, 0, 0, 0);
                endDate.setHours(8, 0, 0, 0);

                if (nowDate.getTime() - beginDate.getTime() >= 0 && nowDate.getTime() <= endDate.getTime()) {
                    // 定时器轮询
                    _this.barrageSetTimeOut(300000, 150000, 150000);
                }
            }

            if (beginDate.getHours() >= 8 && beginDate.getHours() <= 23) {
                // 8-23点，刷新周期为每15s一次。
                beginDate.setHours(8, 0, 0, 0);
                endDate.setHours(23, 0, 0, 0);

                if (nowDate.getTime() - beginDate.getTime() >= 0 && nowDate.getTime() <= endDate.getTime()) {
                    // 定时器轮询
                    _this.barrageSetTimeOut(5000, 5000, 10000);
                }
            }
        },
        // 弹幕轮询定时器
        barrageSetTimeOut: function barrageSetTimeOut(firstTime, begeinTime, lineTime) {
            var _this = this;

            var time = true; // 第一个定时器

            setTimeout(function () {
                Interval5();
            }, firstTime); // 设置第一次定时器

            function Interval5() {
                if (!time) {
                    return;
                } else {
                    var set1 = setInterval(function () {
                        // 请求数据
                        _this.barrageTime();

                        _this.isBarrageList = true; // 开关

                        time = false; // 消除定时器

                        clearInterval(set1); // 隐藏页面

                        setTimeout(function () {
                            _this.isBarrageList = false;
                            Interval10();
                        }, 5000);
                    }, begeinTime);
                }
            }

            ; // 设置第二个定时器

            function Interval10() {
                setTimeout(function () {
                    _this.barrageTime();

                    _this.isBarrageList = true;
                    time = true;
                    Interval5();
                }, lineTime);
            }

            ;
        },
        // 弹幕轮询
        barrageTime: function barrageTime() {
            var _this = this;

            $.ajax({
                url: API + '/course_detail_live_msg',
                type: 'post',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    course_id: _this.course_id
                },
                success: function success(msg) {
                    if (msg.errno == ERROK) {
                        _this.barrageList = msg.data.info;
                    } else {
                        _this.barrageList = '';
                    }
                }
            });
        },
        // 获取当前服务器时间
        getServerTime: function getServerTime() {
            var xmlHttp = false;

            try {
                xmlHttp = new ActiveXObject("Msxml2.XMLHTTP");
            } catch (e) {
                try {
                    xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
                } catch (e2) {
                    xmlHttp = false;
                }
            }

            if (!xmlHttp && typeof XMLHttpRequest != 'undefined') {
                xmlHttp = new XMLHttpRequest();
            }

            // xmlHttp.open("GET", window.location.href.toString(), false);
            xmlHttp.open("GET", BASE_URL, false);
            xmlHttp.setRequestHeader("If-None-Match", "bytes=-1");
            xmlHttp.setRequestHeader("Cache-Control", "no-cache");
            xmlHttp.send(null); //发送get请求

            return new Date(xmlHttp.getResponseHeader("Date")); //从响应头中获取当前网络时间
        },

        infoMore: function infoMore() {
            var _this = this;
            _this.collageMore = true;
        },

        // 关闭查看更多
        collageclose: function collageclose() {
            var _this = this;

            _this.collageMore = false;
        },
        // 页面去参团按钮
        clickgrouppdd: function clickgrouppdd(pdd_order_id) {
            var _this = this;

            _this.orderDateId = pdd_order_id;

            if (!getCookie('uid') && !getCookie('token')) {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                return;
            } // 拼团状态 1未 2已在团 3别人分享团 * （有团不会出现）


            if (_this.groupon_status == 1) {
                _this.collageMore = false;
                _this.isOpenGroup = true;
                _this.isPayType = 0
                _this.groupCreateOidPay(_this.course_id,1, pdd_order_id)
            } else if (_this.groupon_status == 2) {
                _this.collageMore = false;
                _this.isGroudpdd = true;
            }
        },
        // 页面去参团关闭按钮
        collagedClose: function collagedClose() {
            var _this = this;
            _this.isGroudpdd = false;
        },
        // 已参团弹出框邀请按钮
        inorderpdd: function inorderpdd() {
            var _this = this;

            _this.isCollagedtime = true;
            _this.isGroudpdd = false;
            var texturl = MAPI + '/togroup' + '?id=' + _this.currentUserOrderId;
            setTimeout(function () {
                new QRCode(document.getElementById("wcode"), {
                    render: 'canvas',
                    text: texturl,
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    //前景色
                    colorLight: '#ffffff' //背景色

                });
            }, 20);
        },
        // 邀请好友开团
        collagedtime: function collagedtime() {
            if (!getCookie('uid') && !getCookie('token')) {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                return;
            }

            var _this = this;

            _this.isCollagedtime = true; // 生成二维码

            var texturl = MAPI + '/togroup' + '?id=' + _this.currentUserOrderId;
            setTimeout(function () {
                new QRCode(document.getElementById("wcode"), {
                    render: 'canvas',
                    text: texturl,
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    //前景色
                    colorLight: '#ffffff' //背景色

                });
            }, 20);
        },
        // 关闭好友开团模态框
        wshareClose: function wshareClose() {
            var _this = this;

            _this.isCollagedtime = false;
        },
        // 一键开团
        openGroupFuc: function openGroupFuc(price) {
            var _this = this;

            if (!getCookie('uid') && !getCookie('token')) {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                return;
            }

            if (price == 0) {
                _this.isdisabled = true;
                _this.$refs.opengroup.style.background = 'gray';
                _this.$refs.opengroup.style.cursor = 'not-allowed';
                $.ajax({
                    url: API + '/pdd/sys',
                    type: 'post',
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        course_id: _this.course_id
                    },
                    success: function success(msg) {
                        if (msg.errno == 0) {
                            _this.isPaytimezore = setInterval(function () {
                                $.get(API + '/pdd/order_status/' + msg.data.order_id, function (json) {
                                    if (json.errno == 0) {
                                        if (!json.data.info.pay_status) {
                                            return;
                                        }

                                        if (json.data.info.pay_status == 2) {
                                            location.reload();
                                        }

                                        if (json.data.info.pay_status == 3) {
                                            var _this = this;

                                            clearInterval(_this.isPaytimezore);
                                        }
                                    }
                                });
                            }, 2000);
                        }
                    }
                });
            } else {
                _this.groupCreateOidPay(_this.course_id,1,'')
                _this.isOpenGroup = true;
                _this.isPayType = 0
            }
        },
        // 一键开团模态框关闭
        courseClose: function courseClose() {
            var _this = this;
            clearInterval(_this.isPaytime);
            _this.isOpenGroup = false;
            _this.newPayCutIndex = 0
        },
        // 加入购物车
        addCart: function addCart(ev) {
            var _this = this;

            var cid = $('.course_img').attr('data-cid');
            var flyA = $('.fly-a');
            ev = ev || event; //得到事件的坐标

            var startX = ev.clientX;
            var startY = ev.clientY;

            if ($(window).width() <= 1060) {
                var endX = $('#h5_header_menu_switch').offset().left;
                var endY = $('#h5_header_menu_switch').offset().top;
            } else {
                var endX = $('#goods-cart').offset().left;
                var endY = $('#goods-cart').offset().top;
            }

            var totalTime = 1000;
            var moveCount = 50;
            var intervalTime = totalTime / moveCount;
            var moveX = (startX - endX) / moveCount;
            var moveY = (startY - endY) / moveCount;
            $.ajax({
                url: '/cart/add/' + cid,
                type: 'GET',
                dataType: 'json'
            }).success(function (json) {
                if (json.errno == 301) {
                    window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                    return;
                }

                if (json.errno > 500) {
                    alert(json.msg);
                    return;
                }

                if (json.errno == 0) {
                    flyA.css({
                        'display': 'block',
                        'left': startX,
                        'top': startY
                    });
                    var intervalId = setInterval(function () {
                        startX -= moveX;
                        startY -= moveY;

                        if (moveX < 0 && startX >= endX || moveX > 0 && startY <= endY) {
                            $('.fly-a').css({
                                display: 'none'
                            });
                            clearInterval(intervalId);
                        }

                        flyA.css({
                            left: startX + 'px',
                            top: startY + 'px'
                        });
                    }, 10);

                    // 修改购物车数量
                    var num = $('.car-count').html();
                    $('.car-count').html(num == '' ? 1 : (parseInt(num) + 1));
                    _this.initDetail();
                }
            });
        },
        // 分销
        distribution: function distribution() {
            var _this = this;

            $.ajax({
                type: 'get',
                url: '/course/getDist/' + _this.course_id + '/' + distcode,
                dataType: 'json',
                success: function success(data) {

                    if (data.errno == 0) {
                        _this.isDistribution = true;
                        _this.distributionInfo = data.data;
                        _this.isshowmore = true;
                        _this.distributionRanking = _this.rankingslice;

                        _this.distRanking();
                    } else {
                        window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                        return;
                    }
                }
            });
        },
        // 复制分享
        copyShare: function copyShare() {
            /* Act on the event */
            var Url = document.getElementById("valueId");
            Url.select(); // 选择对象

            document.execCommand("Copy"); // 执行浏览器复制命令
        },
        // 关闭分销弹出框
        closeDist: function closeDist() {
            var _this = this;

            _this.isDistribution = false;

            if (_this.is_bound == 0) {
                _this.isAttention = true;

                _this.followService();
            } else {
                _this.isAttention = false;
            }
        },
        // 开始学习
        startStudy: function startStudy() {
            var _this = this;

            if (_this.video_size == 0) {
                // alert('没有视频');
                _this.isVideoLog = true;
            } else {
                window.location.href = BASE_URL + '/video/play/' + _this.v_courseId + '/0/' + _this.course_id;
            }
        },
        // 无视频提示关闭
        closeVideoTip: function closeVideoTip() {
            var _this = this;

            _this.isVideoLog = false;
        },
        // 关注服务号
        followService: function followService() {
            var _this = this;

            var uid = getCookie('uid');
            $.ajax({
                type: 'get',
                url: API + '/wx/user_temporary_qrcode/' + uid,
                dataType: 'json',
                success: function success(data) {
                    _this.showerma = data.data.qr_image;
                    setTimeout(function () {
                        new QRCode(document.getElementById("service_erweima"), data.data.qr_image);
                    });
                }
            });
        },
        // 关闭服务号弹框
        closeAtten: function closeAtten() {
            var _this = this;

            _this.isAttention = false;
        },
        // 微信分享按钮 * 右上角
        wenxinShare: function wenxinShare() {
            var _this = this;

            if (!getCookie('uid') && !getCookie('token')) {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                return;
            }

            _this.isWeixinShare = true; // alert('https://m.julyedu.com/course/spellGroup' + '?groupon_code='+ qrorder+'&id='+<{$data['course_id']}> + '&pccode=1');

            setTimeout(function () {
                // alert(BASE_URL+'/course/getDetail/'+<{$data['course_id']}>);
                new QRCode(document.getElementById("share_qrcode"), BASE_URL + '/course/getDetail/' + course_id);
            }, 200);
        },
        // 微信分享关闭按钮
        weixinClose: function weixinClose() {
            var _this = this;

            _this.isWeixinShare = false;
        },
        // 新浪分享
        sinaShare: function sinaShare() {
            var _this = this;

            if (!getCookie('uid') && !getCookie('token')) {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                return;
            }

            var qqShareUrl = BASE_URL + '/course/getDetail/' + course_id;

            _this.sharetosina(document.title, qqShareUrl, _this.course_image);
        },
        // qq空间分享
        qzoneShare: function qzoneShare() {
            var _this = this;

            if (!getCookie('uid') && !getCookie('token')) {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                return;
            }

            var qqShareUrl = BASE_URL + '/course/getDetail/' + course_id;

            _this.sharetoqqzone(document.title, qqShareUrl, _this.course_image);
        },
        // tab切换
        change: function change(index) {
            this.num = index;

            if (index == 1) {
                this.syllabus();
            }
        },
        // 获取大纲列表
        syllabus: function syllabus() {
            var _this = this;

            $.ajax({
                url: API + '/pc/course/syllabus/' + this.course_id,
                type: 'get',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function success(msg) {
                    if (msg.errno == ERROK) {
                        _this.syllabusList = msg.data; //console.log(_this.syllabusList)
                    }
                }
            });
        },
        // 去学习关闭
        leranStudyClose: function leranStudyClose() {
            var _this = this;

            _this.isLeranStudy = false;
        },
        auditionClose: function auditionClose() {
            var _this = this;

            _this.isaudition = false;
            clearTimeout(_this.auditionTime);
        },
        // 试听
        audition: function (_audition) {
            function audition(_x) {
                return _audition.apply(this, arguments);
            }

            audition.toString = function () {
                return _audition.toString();
            };

            return audition;
        }(function (videoId) {
            var _this = this;

            var share_num = null;
            _this.isaudition = true;
            var textUrl = BASE_URL + '/weekend/download?courseid=' + course_id + '&video=' + videoId;
            setTimeout(function () {
                _this.wraploading = false
                new QRCode(document.getElementById("qrCodeWpay"), {
                    render: 'canvas',
                    text: textUrl,
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    //前景色
                    colorLight: '#ffffff' //背景色

                });
            }, 10);
            _this.auditionTime = setInterval(function () {
                $.ajax({
                    url: '/course/user_audition_video',
                    type: 'post',
                    dataType: 'json',
                    data: {
                        video_id: videoId
                    },
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function success(data) {
                        if (data.errno == ERROK) {
                            localStorage.setItem('share_num', data.data.share_num);

                            if (data.data.is_open == '1') {
                                clearInterval(audition);
                                _this.isaudition = false;
                                _this.isLeranStudy = true;
                                setTimeout(function () {
                                    $(".btn-leran").attr("href", '/video/play/' + _this.v_courseId + '/' + videoId);
                                }, 100);
                            }
                        }
                    }
                });
            }, 1000);
        }),
        // 播放
        toPlay: function toPlay(videoId) {
            var _this = this;

            window.location.href = BASE_URL + "/video/play/" + _this.v_courseId + "/" + videoId;
        },
        // 立即学习
        studyPlay: function studyPlay() {
            var _this = this;

            window.location.href = BASE_URL + "/video/play/" + _this.v_courseId + "/" + _this.classid;
        },

        // 单集购买
        singleSet: function singleSet(id, price, name) {
            var _this = this;

            if (!getCookie('uid') && !getCookie('token')) {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                return;
            }

            _this.isbuy = true;
            _this.isPayType = 1
            _this.price = price;
            _this.classname = name;
            _this.classid = id;
            _this.classCreateOidPay(id,1)
        },
        // 单集购买弹窗关闭
        closeClassBuy(){
            var _this = this;
            _this.isbuy = false;
            _this.step = 1;
            _this.newPayCutIndex = 0
            clearInterval(_this.Interval);
        },
        // 关闭弹窗
        close: function close() {
            var _this = this;
            _this.newPayCutIndex = 0
            _this.isbuy = false;
            _this.step = 1;
            _this.isbar = false;
            _this.iserror = false;
            _this.errortext = '';
            _this.bindiphonetext = '完成';
        },
        // 0元领取
        zerobuyReceive: function zerobuyReceive() {
            var _this = this;

            _this.step = 6;
        },
        // 0元参团
        groupBuy: function groupBuy() {
            var _this = this;

            $.ajax({
                url: API + '/pdd/sys',
                type: 'post',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    course_id: _this.course_id
                },
                success: function success(msg) {
                    if (msg.errno == 0) {
                        _this.step = 8;
                        _this.userimg = getCookie('avatar_file');
                        _this.isPaytimezore = setInterval(function () {
                            $.get(API + '/pdd/order_status/' + msg.data.order_id, function (json) {
                                if (json.errno == 0) {
                                    _this.orderIdInvite = json.data.info.pdd_order_id;

                                    _this.countTime(_this.orderIdInvite);

                                    if (!json.data.info.pay_status) {
                                        return;
                                    }

                                    if (json.data.info.pay_status == 2) {
                                        // location.reload()
                                    }

                                    if (json.data.info.pay_status == 3) {
                                        var _this = this;
                                        clearInterval(_this.isPaytimezore);
                                    }
                                }
                            });
                        }, 2000);
                    }
                }
            });
        },
        countTime: function countTime(orderIdInvite) {
            var _this = this;

            $.ajax({
                url: API + '/pdd_order_end_time/' + orderIdInvite,
                type: 'get',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function success(msg) {
                    if (msg.errno == 0) {
                        _this.countEndtime = msg.data.end_time;
                    }
                }
            });
        },

        // 邀请好友参团
        inviteGroupBuy: function inviteGroupBuy() {
            var _this = this;

            _this.step = 9;
            var texturl = MAPI + '/togroup' + '?id=' + _this.currentUserOrderId;
            setTimeout(function () {
                new QRCode(document.getElementById("inviteQrcode"), {
                    render: 'canvas',
                    text: texturl,
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    //前景色
                    colorLight: '#ffffff' //背景色

                });
            }, 20);
        },
        // 砍价相关
        // 砍价是否结束  邀请好友二维码
        isoverBar: function isoverBar() {
            var _this = this;

            $.ajax({
                url: API + '/sys/course_detail/bargain_info/' + course_id,
                type: 'get',
                dataType: 'json',
                cache: false,
                xhrFields: {
                    withCredentials: true
                },
                success: function success(msg) {
                    if (msg.errno == 0) {
                        _this.isendbar = msg.data.is_end; // 是否结束砍价

                        _this.endtimepay = msg.data.end_time; // 支付倒计时

                        _this.shareLike = msg.data.share_like;

                        if (_this.shareLike && _this.shareLike.indexOf("?") != -1) {
                            _this.shareLike = _this.shareLike.split("?")[0];
                            _this.shareLike = _this.shareLike + '?id='+_this.course_id +'&bargaincode=' + msg.data.bargain_code + '&is_originator=0';
                        } // 分享链接


                        _this.ykprice = msg.data.bargain_price; // 砍掉的金额

                        if (_this.isbar && _this.barStep == 2) {
                            setTimeout(function () {
                                new QRCode(document.getElementById("invitcode1"), {
                                    render: 'canvas',
                                    text: _this.shareLike,
                                    width: 172,
                                    height: 172,
                                    colorDark: '#000000',
                                    //前景色
                                    colorLight: '#ffffff' //背景色

                                });
                            }, 20);
                        }
                    }
                }
            });
        },
        // 验证手机号
        changeiphone: function changeiphone() {
            var _this = this;
            _this.iserror = false;
            _this.errortext = '';
            _this.bindiphonetext = '完成';

            var reg = 11 && /^((13|14|15|16|17|18)[0-9]{1}\d{8})$/;

            if (!reg.test(this.iphone)) {
                _this.byiphone = true;
                _this.isbindall = true;
            } else {
                _this.byiphone = false;
                _this.isbindall = false;
            }
        },
        // 获取验证码
        getCode: function getCode() {
            var _this = this;

            var data = {};
            data.phone_num = _this.iphone;
            data.action = 'auth';
            data.vali_code = '';
            $.ajax({
                url: '/passport/quickSendSms',
                type: "post",
                data: data,
                success: function success(res) {
                    if (res.errno == 0) {
                        _this.timeInterval = setInterval(function () {
                            _this.getCodeTime--;
                            _this.btntext = _this.getCodeTime + "s后重新获取";
                            _this.byiphone = true;
                            _this.countdown = true;

                            if (_this.getCodeTime <= 0) {
                                clearInterval(_this.timeInterval);
                                _this.btntext = "发送验证码";
                                _this.countdown = false;
                                _this.byiphone = false;
                                _this.getCodeTime = 60;
                            }
                        }, 1000);
                    } else if (res.errno == 410) {
                        _this.iserror = true;
                        _this.errortext = '该手机号已注册，请使用该手机号登录，发起砍价。';
                        _this.bindiphonetext = '去登录';
                    } else if (res.errno == 0) {
                        _this.iserror = false;
                        _this.errortext = '';
                    } else {
                        _this.iserror = true;
                        _this.errortext = res.msg;
                    }
                }
            });
        },
        // 验证绑定手机号是否成功
        bySuccess: function bySuccess() {
            var _this = this;

            if (_this.bindiphonetext == '完成') {
                if (_this.iphonecode == '') {
                    _this.iserror = true;
                    _this.errortext = '请输入验证码';
                } else {
                    var data = {};
                    data.phone_num = _this.iphone;
                    data.action = 'auth';
                    data.vali_code = _this.iphonecode;
                    $.ajax({
                        url: '/passport/bindPhone/2',
                        type: "post",
                        data: data,
                        success: function success(res) {
                            if (res.errno == 0) {
                                _this.isbar = true;
                                _this.barStep = 2;

                                _this.tokanjan(1);
                            }

                            if (res.errno == 410) {
                                _this.iserror = true;
                                _this.errortext = '该手机号已注册，请使用该手机号登录，发起砍价。';
                                _this.bindiphonetext = '去登录';
                            } else {
                                _this.iserror = true;
                                _this.errortext = res.msg;
                            }
                        }
                    });
                }
            } else {
                Tool.logout();
                window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
            }
        },
        // 是否绑定了手机号
        isbindiphone: function isbindiphone() {
            var _this = this;

            $.ajax({
                url: API + '/sys/user_status',
                type: 'get',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function success(msg) {
                    if (msg.errno == 0) {
                        if (msg.data.result == 2 || msg.data.result == 3) {
                            _this.isbar = true;
                            _this.barStep = 2;

                            _this.tokanjan(1);
                        } else {
                            _this.isbar = true;
                            _this.barStep = 0;
                        }
                    } else if (msg.errno == 4030) {
                        window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                    }
                }
            });
        },
        // 砍价接口
        tokanjan: function tokanjan(type) {
            var _this = this;

            $.ajax({
                url: API + '/sys/to_kanjia/' + course_id + '/' + type + '/0',
                type: 'get',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function success(msg) {
                    if (msg.errno == 0) {
                        _this.fristprice = msg.data.amount;

                        _this.isoverBar();
                    } else {
                        alert(msg.msg);
                    }
                }
            });
        },
        // 是否开始砍价
        iskanjia: function iskanjia() {
            var _this = this;

            $.ajax({
                url: API + '/sys/user_kanjia_step/' + course_id,
                type: 'get',
                dataType: 'json',
                cache: false,
                xhrFields: {
                    withCredentials: true
                },
                success: function success(msg) {
                    if (msg.errno == 0) {
                        _this.statusbar = msg.data.status;
                    }
                }
            });
        },
        // 获取好友砍价记录
        barRecord: function barRecord() {
            var _this = this;

            $.ajax({
                url: API + '/sys/friends_bargain_list/' + course_id + '/0',
                type: 'get',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function success(msg) {
                    if (msg.errno == 0) {
                        _this.friendslist = msg.data.list;

                        if (msg.data.list) {
                            if (msg.data.list.length >= 3) {
                                _this.friends = msg.data.list.slice(0, 3);
                            } else {
                                _this.friends = msg.data.list;
                            }
                        }
                    }
                }
            });
        },
        // 查看砍价排行榜
        toranking: function toranking() {
            var _this = this;

            _this.isbar = true;
            _this.barStep = 1;
        },
        // 我要砍价
        bargainBar: function bargainBar() {
            var _this = this;

            if (_this.islogin) {
                _this.isbindiphone();
            } else {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
            }
        },
        // 领取砍价神器
        artifact: function artifact() {
            var _this = this;

            _this.isbar = true;
            _this.barStep = 3;
            $.ajax({
                url: API + '/sys/receive_limit/' + course_id,
                type: 'get',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function success(msg) {
                    if (msg.errno == 0) {
                    }
                }
            });
        },
        // 领取砍价神器之后再砍一刀
        againBar: function againBar() {
            var _this = this;

            _this.isbar = true;
            _this.barStep = 4;

            _this.tokanjan(2);

            _this.getVipVideo();
        },
        // 邀请好友继续砍价
        invitbar: function invitbar() {
            var _this = this;

            _this.isbar = true;
            _this.barStep = 5;
            setTimeout(function () {
                new QRCode(document.getElementById("invitcode"), {
                    render: 'canvas',
                    text: _this.shareLike,
                    width: 172,
                    height: 172,
                    colorDark: '#000000',
                    //前景色
                    colorLight: '#ffffff' //背景色

                });
            }, 20);
        },
        // 直接购买
        addtobuy: function addtobuy() {
            var _this = this;
            if (_this.islogin == 1) {
                if (_this.isbargin == 1 && (_this.statusbar == 0 || _this.statusbar == 1)) {
                    _this.isbar = true;
                    _this.barStep = 6;
                } else {
                    window.location.href = _this.bao_url;
                }
            } else {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURIComponent(document.URL);
            }
        },
        removebar: function removebar() {
            var _this = this;

            $.ajax({
                url: API + '/sys/revoke_course_bargain',
                type: 'post',
                data: {
                    'course_id': course_id
                },
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function success(msg) {
                    if (msg.errno == 200) {
                        _this.isbar = false;
                        window.location.href = _this.bao_url;
                    } else {
                        alert(msg.msg);
                    }
                }
            });
        },
        // 是否显示分享领红包
        shareactive: function shareactive() {
            var _this = this;
            $.ajax({
                url: API + '/sys/red_packet/show_share_active/' + course_id,
                type: 'get',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function success(msg) {
                    if (msg.errno == 200) {
                        _this.isshare = msg.data.status;
                    } else {
                        alert(msg.msg);
                    }
                }
            });
        },

        // 分享领红包
        sharecode: function sharecode() {
            var _this = this;
            if (_this.islogin) {
                _this.sharembc = true;
                _this.openshare = 1;
                $.ajax({
                    type: 'get',
                    url: `${FAST}/sys/redPacket/shareUrl/${course_id}`,
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(res => {
                    if (res.code == 200) {
                        _this.shareData = res.data
                        setTimeout(function () {
                            new QRCode(document.getElementById("shareqrcode"), {
                                render: 'canvas',
                                text:  _this.shareData.url,
                                width: 90,
                                height: 90,
                                colorDark: '#000000',
                                //前景色
                                colorLight: '#ffffff' //背景色

                            });
                        }, 20);
                    } else if(res.code == 4030 || res.code == 4040){
                        window.location.href = PASSPORT + "/login?redirect=" + encodeURIComponent(document.URL);
                    }
                });


            } else {
                Tool.setCookie('share_code', 'share_code')
                window.location.href = PASSPORT + "/login?redirect=" + encodeURIComponent(document.URL);
            }

        },
        // 复制分享领红包的口令
        copyCommand: function copyCommand() {
            this.toCopy = false
            this.$refs.copyEle.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
        },
        // 引导关注公众号
        closeShare: function closeShare() {
            var _this = this;
            if(_this.shareData.is_follow == 0){
                _this.openshare = 2;
                _this.followService();
            } else {
                _this.sharembc = false;
            }
        },
        // 关闭弹窗
        closeShare2: function closeShare() {
            var _this = this;
            _this.sharembc = false;
        },
        closeModal(prop) {
            this[prop] = false
        },
        validateDepositInformation() {
            let {agree, name, tel, qq} = this.user;

            this.userError.name = !name;
            this.userError.tel = (!tel || !/^1[3-9]\d{9}$/.test(tel));
            this.userError.qq = !qq;
            this.userError.agree = !agree;

            return Object.values(this.userError).filter(item => !item).length
        },
        depositConfirm() {
            const requiredFieldsLength = Object.values(this.user).length - 1;
            if (this.validateDepositInformation() === requiredFieldsLength) {
                if (this.user.hasInfo) {
                    this.createDepositOrder(() => {

                        this.depositStep = 2;
                    });
                } else {
                    $.ajax({
                        url: API + '/web/order/saveUserInfo',
                        method: 'POST',
                        xhrFields: {
                            withCredentials: true
                        },
                        data: {
                            real_name: this.user.name,
                            cellphone: this.user.tel,
                            qq: this.user.qq
                        }
                    }).done(res => {
                        if (res.errno == 200) {

                            this.createDepositOrder(() => {
                                this.depositStep = 2;

                            })

                        } else {
                            alert(res.msg)
                        }
                    })
                }
            }
        },
        depositPay() {
            if (!this.islogin) {
                window.location.href = `//passport.julyedu.com/login?redirect=${encodeURIComponent(location.href)}`;
                return;
            }
            $.ajax({
                type: 'POST',
                url: `${API}/web/deposit/preorder`,
                data: {course_id},
                xhrFields: {
                    withCredentials: true
                }
            }).done(res => {
                if (res.errno == 200) {
                    this.depositAmount = res.data.total_sale;
                    if (Object.values(res.data.user_info).length != 0) {
                        let {real_name, cellphone, qq} = res.data.user_info
                        this.user.name = real_name;
                        this.user.tel = cellphone;
                        this.user.qq = qq;
                        if (real_name && cellphone && qq) {
                            this.user.hasInfo = true;
                        }
                    }
                }
            });
            this.depositPaymentModal = true
        },
        createDepositOrder(cb) {
            $.ajax({
                url: API + '/web/deposit/create',
                method: 'POST',
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    plat_form: 0,
                    source: 1,
                    course_id
                }
            }).done(res => {
                if (res.errno == 200) {

                    $.ajax({
                        url: BASE_URL + '/pay/wxpay',
                        method: 'POST',
                        data: {
                            oid: res.data.order_id
                        },
                        xhrFields: {
                            withCredentials: true
                        },
                        timeout: 0,
                        dataType: 'json'
                    }).done(response => {
                        if (response.errno == 0) {
                            cb && cb();
                            setTimeout(() => {
                                this.generateQRCode('deposit-qrcode', response.data.code_url);
                                this.depositTimer = setInterval(() => {
                                    this.purchaseStatus(res.data.order_id)
                                }, 3000);
                            }, 20);

                        } else {
                            alert(response.msg)
                        }
                    })

                } else {
                    alert(res.msg)
                }
            })
        },
        generateQRCode(id, text) {
            new QRCode(document.getElementById(id), {
                render: 'canvas',
                text,
                width: 150,
                height: 150,
                colorDark: '#000000', //前景色
                colorLight: '#ffffff' //背景色
            });
        },
        purchaseStatus(oid) {
            $.ajax({
                url: API + '/sys/order_status/' + oid,
            }).done(res => {
                if (res.errno == 0) {
                    clearInterval(this.depositTimer);
                    this.fetchShareCouponInfo(oid);
                }
            })
        },
        fetchShareCouponInfo(oid) {
            $.ajax({
                url: API + '/web/deposit/coupon',
                method: 'POST',
                data: {
                    order_id: oid
                }
            }).done(res => {
                if (res.errno == 200) {
                    this.depositPaymentModal = false;
                    this.depositCoupon = res.data;
                    this.depositShareModal = true;

                    setTimeout(() => {
                        this.generateQRCode('share-expansion-coupon-qrcode', res.data['share_url']);
                    }, 20);


                } else {
                    alert(res.msg)
                }
            })
        },
        closeShareModal() {
            this.depositShareModal = false;
            location.reload();
        },
        toArrearsPage() {
            if (Date.now() / 1000 < this.depositInfo.start_timestamp) {

                toast(`付尾款将在${this.depositInfo.final_start_time}开启`)
            } else {

                location.assign('/cart/depositOrder')
            }
        },
        courseEnrollment() {
            $.ajax({
                url: '/cart/o',
                method: 'POST',
                data: {cid: [course_id], type: 1}
            }).done(res => {
                if (res.errno == 0) {
                    location.assign('/cart/order/type/1')
                }
            })
        },
        toExam(value) {
            if (!value.is_open || !value.video_auth) {
                return;
            }
            if (value.practice.is_tested) {
                location.assign(`${location.origin}/Exam/campResult?video_id=${value.video_id}&qid=${value.practice.qid}`)

            } else {

                location.assign(`${location.origin}/Exam/campTest?video_id=${value.video_id}&qid=${value.practice.qid}`)
            }
        },
        freeReceive(){
            $.ajax({
                url: `${FAST}/sys/limitFree/receive`,
                method: 'POST',
                data: {course_id:this.course_id},
                xhrFields: {withCredentials: true},
            }).done(res => {
                if (res.code === 200) {
                    this.isshowLimitFree = true
                    this.initDetail();
                }else if (res.code === 4030 || res.code === 4031) {
                    window.location.href = PASSPORT + "/login?redirect=" + encodeURIComponent(document.URL);
                } else {
                    alert(res.msg)
                }
            })

        },
        timeEnd(){
            this.initDetail();
        },

        // 支付弹窗优化。新增支付宝支付
        // 优化之后同时生成订单号和支付二维码 默认选中微信
        // 3个参数 课程ID、支付选项 1-微信 2-支付宝、小团订单ID 空-创建拼团 非空-参团

        // 开团、参团下单及生成支付二维码
        groupCreateOidPay(course_id,pay_option,pdd_order_id){
            var _this = this
            $.ajax({
                url: API + '/pdd/direct_create',
                type: 'post',
                dataType: 'json',
                data: {
                    course_id: course_id,
                    pay_option: pay_option,
                    pdd_order_id: pdd_order_id
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function success(data) {
                    if (data.errno == 0) {
                        _this.newPayOrderId = data.data.order_id
                        setTimeout(function () {
                            new QRCode(document.getElementById("newPayCode"), {
                                text: data.data.code_url,
                                width: 140,
                                height: 140,
                                colorDark: '#000000',
                                //前景色
                                colorLight: '#ffffff' //背景色
                            }, 20);
                        });
                        // 查询支付状态
                        _this.groupStatus(data.data.order_id)
                    }else {
                        alert(data.msg);
                    }
                }
            });
        },
        // 单集购买下单及生成支付二维码
        classCreateOidPay(video_id,pay_option){
            var _this = this
            $.ajax({
                url: API + '/sys/order/direct_create_class',
                type: 'post',
                dataType: 'json',
                data: {
                    video_id: video_id,
                    pay_option: pay_option
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function success(data) {
                    if (data.errno == 0) {
                        _this.newPayOrderId = data.data.order_id

                        setTimeout(function () {
                            new QRCode(document.getElementById("qrcodebox"), {
                                text: data.data.code_url,
                                width: 140,
                                height: 140,
                                colorDark: '#000000',
                                //前景色
                                colorLight: '#ffffff' //背景色
                            }, 20);
                        });
                        // 查询支付状态
                        _this.classBuyStatus(data.data.order_id)
                    }else {
                        alert(data.msg);
                    }
                }
            });
        },
        // 拼团支付状态查询
        groupStatus(oid){
            var _this =this
            _this.isPaytime = setInterval(function () {
                $.get(API + '/pdd/order_status/' + oid, function (json) {
                    if (json.errno == 0) {

                        // pay_status 1参加拼团【未支付】 2等待成团【已支付】 3拼团成功【已支付】 4后台操作退款【个人原因】 5时间到未拼团成功退款【正常流程退款】
                        if (!json.data.info.pay_status) {
                            return;
                        }

                        if (json.data.info.pay_status == 2 || json.data.info.pay_status == 3) {
                            clearInterval(_this.isPaytime);
                            _this.isOpenGroup = false;
                            _this.payComplete = true
                        }

                    }
                });
            }, 3000);
        },
        // 单集支付状态查询
        classBuyStatus(oid){
            var _this =this
            _this.Interval = setInterval(function () {
                $.ajax({
                    url: API + '/class_order_status/' + oid,
                    type: 'get',
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function success(msg) {
                        //  _this.step = 3 //  3正常  5击穿直接购买  7击穿0元拼团  4第一次购买
                        if (msg.data.errno == '200') {
                            clearInterval(_this.Interval);
                            _this.step = 3;
                        }

                        if (msg.data.errno == '201') {
                            clearInterval(_this.Interval);
                            _this.step = 5;
                        }

                        if (msg.data.errno == '202') {
                            clearInterval(_this.Interval);
                            _this.step = 7;
                        }

                        if (msg.data.errno == '203') {
                            _this.nowPrice = msg.data.data.now_price;
                            _this.laterPrice = msg.data.data.three_day_later_price;
                            clearInterval(_this.Interval);
                            _this.step = 4;
                        }
                    }
                });
                }, 3000);
        },
        // 选择支付方式
        selectPayType(item,index){
            this.newPayCutIndex = index
            if(this.isPayType === 0){
                clearInterval(this.isPaytime);
                document.getElementById("newPayCode").innerHTML = ''
                this.groupCreateOidPay(this.course_id, item.type,this.orderDateId)
            } else {
                clearInterval(this.Interval);
                document.getElementById("qrcodebox").innerHTML = ''
                this.classCreateOidPay(this.classid,item.type)
            }
        },

        // 拼团支付完成
        payCompleteFun(){
            location.reload();
        }
    }
});


function toast(msg, duration = 2000) {
    let $div = $(`<div class="toast">${msg}</div>`);
    $('body').append($div);
    setTimeout(function () {
        $($div).remove()
    }, duration);
}
